import type { EngineeringDiscipline } from '../../data/engineering'
import { DisciplineCard } from './DisciplineCard'

export function DisciplineGrid({ disciplines }: { disciplines: EngineeringDiscipline[] }) {
  return <div className="eng-discipline-grid">{disciplines.map((discipline) => <DisciplineCard discipline={discipline} key={discipline.id} />)}</div>
}
